import { observer } from 'mobx-react';
import DateInput from '../../../Form/DateInput';
import TimeInput from '../../../Form/TimeInput';
import TimeZoneSelect from '../../../Form/TimeZoneSelect';
import { ShareStore } from './Stores/ShareStore';

interface SchedulingFieldsProps {
  shareStore: ShareStore;
}

function SchedulingFields({ shareStore }: SchedulingFieldsProps) {
  const handleDateChange = (dateString: string) => {
    const [year, month, day] = dateString.split('-').map(Number);
    const currentTime = shareStore.scheduleTime.getOrElseValue(new Date());
    const newDate = new Date(
      year,
      month - 1,
      day,
      currentTime.getHours(),
      currentTime.getMinutes(),
    );
    shareStore.updateScheduleDate(newDate);
  };

  const handleTimeChange = (timeString: string) => {
    const [hours, minutes] = timeString.split(':').map(Number);
    const currentDate = shareStore.scheduleDate.getOrElseValue(new Date());
    const newTime = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      hours,
      minutes,
    );
    shareStore.updateScheduleTime(newTime);
  };

  const handleTimezoneChange = (timezone: string) => {
    shareStore.updateScheduleTimezone(timezone);
  };

  switch (shareStore.state.kind) {
    case 'waiting':
    case 'loading':
    case 'error':
      return <></>;
    case 'ready':
    case 'searching':
    case 'reviewing':
    case 'refreshing':
    case 'publishing':
    case 'submitting':
    case 'confirming':
      return (
        <div className="flex gap-4">
          <DateInput
            setDate={handleDateChange}
            date={shareStore.state.scheduleDate}
            disabled={false}
          />
          <TimeInput
            setTime={handleTimeChange}
            time={shareStore.state.scheduleTime}
            disabled={false}
          />
          <TimeZoneSelect
            setTimezone={handleTimezoneChange}
            timezone={shareStore.state.scheduleTimezone}
            disabled={false}
          />
        </div>
      );
  }
}

export default observer(SchedulingFields);
